import * as React from "react"
import { Box, Text, Link, useThemeUI, Container } from "theme-ui"
import { ThemeProvider } from "@emotion/react"
import { FaWhatsapp } from "@react-icons/all-files/fa/FaWhatsapp"
import { FaRegEnvelope } from "@react-icons/all-files/fa/FaRegEnvelope"
import { HiOutlinePhone } from "@react-icons/all-files/hi/HiOutlinePhone"
import * as componentStyle from "assets/css/components.module.css"
import styled from "@emotion/styled"

const TopBarDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${(props) => props.theme.colors.background};
    background: ${(props) => props.theme.colors.secondary};
    padding: 16px;
    height: 50px;
    @media screen and (max-width: ${(props) => props.theme.breakpoints[3]}) {
        flex-direction: column;
    }

    & .member-of {
        font-size: ${(props) => props.theme.fontSizes[3]}px;
        color: white;
        display: flex;
        alignitems: center;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        & .member-of {
            font-size: ${(props) => props.theme.fontSizes[2]}px;
        }
    }
`

const ContactBox = styled.div`
    line-height: ${(props) => props.theme.space[2]}px;
    text-align: center;
    font-size: ${(props) => props.theme.fontSizes[3]}px;
    color: ${(props) => props.theme.colors.background};

    & a {
        color: ${(props) => props.theme.colors.background};
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        font-size: ${(props) => props.theme.fontSizes[2]}px;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[3]}) {
        display: none;
    }

    & span {
        vertical-align: baseline;
    }
`

const TopBar = ({company}) => {
    const data = company
    const context = useThemeUI()
    const { theme } = context

    let whatsapp = null
    if (data.whatsapp) {
        whatsapp = data.whatsapp.replace(/ /g, "").replace("+", "")
    }
    return (
        <ThemeProvider theme={theme}>
            <TopBarDiv>
                <Container
                    sx={{
                        p: 0,
                        display: "flex",
                        justifyContent: "space-between",
                    }}
                >
                    <Box className="member-of">
                        <Text sx={{ fontStyle: "italic", color: "background" }}>
                            A member of
                        </Text>{" "}
                        <Link
                            href="https://dynamics.com.sg/"
                            target="_blank"
                            sx={{
                                color: "background",
                                textDecoration: "underline",
                                paddingRight: 1,
                            }}
                        >
                            &nbsp;Dynamics Therapy Group
                        </Link>
                        <img
                            src={"/umbrella.svg"}
                            alt="Dynamics Therapy Group"
                            width="24"
                            height="14"
                        />
                    </Box>
                    <ContactBox>
                        <span className={componentStyle.reactIcons}></span>
                        <span>
                            <HiOutlinePhone
                                style={{ verticalAlign: "initial" }}
                            />{" "}
                            <Link
                                href={`tel:${data.tel}`}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {data.tel}
                            </Link>
                        </span>
                        <span className={componentStyle.reactIcons}></span>
                        <span>
                            <FaWhatsapp style={{ verticalAlign: "initial" }} />{" "}
                            <Link
                                href={`https://wa.me/${whatsapp}`}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {data.whatsapp}
                            </Link>
                        </span>
                        <span className={componentStyle.reactIcons}></span>
                        <span>
                            <FaRegEnvelope
                                style={{ verticalAlign: "text-bottom" }}
                            />{" "}
                            <Link
                                href={`mailto:${data.email}`}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {data.email}
                            </Link>
                        </span>
                    </ContactBox>
                </Container>
            </TopBarDiv>
        </ThemeProvider>
    )
}

export default TopBar
